export interface AllegroReturnPolicies {
  returnPolicies: AllegroReturnPolicy[];
  count: number;
}

export interface AllegroReturnPolicy {
  id: string;
  seller: AllegroReturnPolicySeller;
  name: string;
  availability: AllegroReturnPolicyAvailability;
  withdrawalPeriod?: string | null;
  returnCost?: AllegroReturnPolicyReturnCost | null;
  address?: AllegroReturnPolicyAddress | null;
  contact?: AllegroReturnPolicyContact | null;
  options?: AllegroReturnPolicyOptions | null;
}

export interface AllegroCreateOrUpdateReturnPolicyRequest {
  name: string;
  availability: AllegroReturnPolicyAvailability;
  withdrawalPeriod?: string | null;
  returnCost?: AllegroReturnPolicyReturnCost | null;
  address?: AllegroReturnPolicyAddress | null;
  contact?: AllegroReturnPolicyContact | null;
  options?: AllegroReturnPolicyOptions | null;
}

export interface AllegroReturnPolicySeller {
  id: string;
}

export interface AllegroReturnPolicyAvailability {
  range: AllegroReturnPolicyAvailabilityRange;
  restrictionCause?: AllegroReturnPolicyRestrictionCause | null;
}

export enum AllegroReturnPolicyAvailabilityRange {
  FULL = 'FULL',
  RESTRICTED = 'RESTRICTED',
  DISABLED = 'DISABLED',
}

export interface AllegroReturnPolicyRestrictionCause {
  name?: AllegroReturnPolicyRestrictionCauseName;
  description?: string;
}

export enum AllegroReturnPolicyRestrictionCauseName {
  SEALED_MEDIA = 'SEALED_MEDIA',
  SEALED_ITEM_NO_RETURN_DUE_HEALTH_OR_HYGIENE = 'SEALED_ITEM_NO_RETURN_DUE_HEALTH_OR_HYGIENE',
  CUSTOM_ITEM = 'CUSTOM_ITEM',
  SHORT_SHELF_LIFE = 'SHORT_SHELF_LIFE',
  INSEPARABLY_LINKED = 'INSEPARABLY_LINKED',
  PRESS = 'PRESS',
  MEDICINAL_PRODUCT = 'MEDICINAL_PRODUCT',
  NOT_RECORDED_DIGITAL_CONTENT = 'NOT_RECORDED_DIGITAL_CONTENT',
  VALUE_DEPENDENT_ON_FINANCIAL_MARKET = 'VALUE_DEPENDENT_ON_FINANCIAL_MARKET',
  ALCOHOL = 'ALCOHOL',
  FULLY_IMPLEMENTED_SERVICE = 'FULLY_IMPLEMENTED_SERVICE',
  BOOKED_SERVICE = 'BOOKED_SERVICE',
}

export interface AllegroReturnPolicyReturnCost {
  coveredBy: AllegroReturnPolicyReturnCostCoveredBy;
}

export enum AllegroReturnPolicyReturnCostCoveredBy {
  SELLER = 'SELLER',
  BUYER = 'BUYER',
}

export interface AllegroReturnPolicyAddress {
  name: string;
  street: string;
  postCode: string;
  city: string;
  countryCode: string;
}

export interface AllegroReturnPolicyContact {
  phoneNumber?: string | null;
  email?: string | null;
}

export interface AllegroReturnPolicyOptions {
  cashOnDeliveryNotAllowed: boolean;
  freeAccessoriesReturnRequired: boolean;
  refundLoweredByReceivedDiscount: boolean;
  businessReturnAllowed: boolean;
  collectBySellerOnly: boolean;
}
